import { TableFilterState } from '@/components/data-table/filters-v2';

export const TIME_OFF_QUERY_KEY_ROOT = 'time-off';

export const TIME_OFF_BALANCES_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'balances'];
export const TIME_OFF_REQUESTS_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'requests'];

export const getTimeOffRequestsQueryKey = (
  filters: TableFilterState,
  currentUserId?: number,
  canViewOtherTimeOffs?: boolean
) => [...TIME_OFF_REQUESTS_QUERY_KEY, filters, currentUserId, canViewOtherTimeOffs];

export const getTimeOffRequestDetailsQueryKey = (requestId: number) => [
  ...TIME_OFF_REQUESTS_QUERY_KEY,
  'detail',
  requestId,
];

export const getTimeOffBalanceByTypeQueryKey = (typeId: number) => [
  ...TIME_OFF_BALANCES_QUERY_KEY,
  'type',
  typeId,
];

export const SUGGESTED_APPROVERS_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'suggested-approvers'];

/** Root for the create-mode live balance preview — never cached across inputs (see the hook). */
export const TIME_OFF_BALANCE_PREVIEW_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'balance-preview'];

/** Root for the working-days cache — invalidate it when the org work schedule changes. */
export const WORKING_DAYS_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'working-days'];

export const getWorkingDaysQueryKey = (startDate: string, endDate: string) => [
  ...WORKING_DAYS_QUERY_KEY,
  startDate,
  endDate,
];
